import type { StateCreator } from "zustand"
import { devtools } from "zustand/middleware"
/**
 * A utility function to wrap Zustand state creators with Redux DevTools support.
 * It conditionally applies the devtools middleware based on the environment.
 *
 * @param initializer - The Zustand state creator to be wrapped.
 * @param name - The name of the store for debugging purposes.
 * @returns A Zustand state creator wrapped with devtools if in development mode.
 */
export function withDevtools<S>(initializer: StateCreator<S, any, any, S>, name: string): StateCreator<S, any, any, S> {
  const formattedTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })

  const enabledForCurrentEnv = import.meta.env.VITE_ENV === "development" || import.meta.env.VITE_ENV === "staging"
  const url = typeof window !== "undefined" ? window.location.pathname : "unknown"
  const devtoolsName = `Akrochem: ${name} (${url}) ${formattedTime}`

  return enabledForCurrentEnv ? devtools(initializer, { name: devtoolsName }) : initializer
}
